module.exports = __webpack_public_path__ + "static/media/marker.7ea0be3b.svg";